import type { UnionTypeLibelle } from '@/features/domaine/types/techniques'

export const Dispositif = ['CAPP', 'CPRO', 'PROA', 'AF'] as const
export type Dispositif = (typeof Dispositif)[number]

export const DispositifLibelle: UnionTypeLibelle<Dispositif> = {
  CAPP: "Contrat d'apprentissage",
  CPRO: 'Contrat de professionnalisation',
  PROA: 'Reconversion ou promotion par alternance',
  AF: 'Action de formation',
} as const

export const DispositifLibelleCreation: UnionTypeLibelle<Dispositif> = {
  CAPP: "Nouveau contrat d'apprentissage",
  CPRO: 'Nouveau contrat de professionnalisation',
  PROA: 'Nouvelle reconversion ou promotion par alternance (PROA)',
  AF: 'Nouvelle Action de formation',
} as const
